import './style/global.less'
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConfigProvider } from '@arco-design/web-react'
import zhCN from '@arco-design/web-react/es/locale/zh-CN'
import enUS from '@arco-design/web-react/es/locale/en-US'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import store from './store'
import PageLayout from './layout'
import { GlobalContext } from './context'
import changeTheme from './utils/changeTheme'
import useStorage from './hooks/useStorage'
import { useMountedState } from './hooks/useMountedState'
import {
  setClientHeight,
  setClientWidth,
  updateUserInfo,
} from '@/store/slices/appSlice'
import debounce from 'lodash/debounce'
import Auth from './Auth.jsx'
import Login from './components/Login'
import { getSetting } from '@/utils/settings'

const KEY_LANG = getSetting('KEY_LANG')

function Index() {
  const [lang, setLang] = useStorage(KEY_LANG, 'zh-CN')
  const [theme, setTheme] = useStorage('arco-theme', 'light')
  // const [theme, setTheme] = useStorage('arco-theme', 'dark')
  const isMounted = useMountedState()
  const dispatch = store.dispatch
  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN
      case 'en-US':
        return enUS
      default:
        return zhCN
    }
  }
  const handleResize = debounce(() => {
    dispatch(setClientHeight(document.documentElement.clientHeight))
    dispatch(setClientWidth(document.documentElement.clientWidth))
  }, 300)

  useEffect(() => {
    if (!isMounted()) return
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    changeTheme(theme)
  }, [theme])

  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme,
  }

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {},
          List: {},
          Table: {},
        }}
      >
        <Provider store={store}>
          <GlobalContext.Provider value={contextValue}>
            <Switch>
              <Route path="/login">
                <Login />
              </Route>
              <Route path="/register">
                <Login />
              </Route>
              <Route path="/">
                <Auth>
                  <PageLayout />
                </Auth>
              </Route>
            </Switch>
          </GlobalContext.Provider>
        </Provider>
      </ConfigProvider>
    </BrowserRouter>
  )
}

ReactDOM.render(<Index />, document.getElementById('root'))

